module.exports = __webpack_public_path__ + "static/media/info2.160995af.svg";